import { useLayoutEffect } from 'react';

/**
 * Side-effect: initializes the styles on the `outerElement` of a collapsible component
 */
export const useInitialStylesOnMount = (isCollapsed: boolean, outerElement: HTMLElement | null) =>
  useLayoutEffect(() => {
    if (outerElement) {
      Object.assign(outerElement.style, {
        height: isCollapsed ? 0 : null,
        overflow: isCollapsed ? 'hidden' : 'initial',
      });
    }
  }, [outerElement]);
